import {useWindowWidth} from "../../../../../services/useWindowWidth";
import React from "react";
import cx from "classnames";

import {typografText} from "../../utils/typograf";
import type {ChecklistCardData} from "../../types";
import OutlinedButton from "../buttons/Outlined";
import ContainedButton from "../buttons/Contained";
import H3 from "../typography/H3";
import List1 from "../typography/List1";

import styles from './ChecklistCard.module.scss';

type ChecklistCardProps = {
    card: ChecklistCardData;
    isReversed?: boolean;
    isScenario?: boolean;
    showScenarioButtons?: boolean;
};

function ChecklistCard({card, isReversed, isScenario, showScenarioButtons = true}: ChecklistCardProps) {
    const width = useWindowWidth();
    const desktopDemoIcon = 'play';
    const demoIcon = width <= 767 ? null : desktopDemoIcon;

    if (isScenario) {
        return (
            <div className={cx(styles.card, styles.scenarioCard)}>
                <div className={styles.textContainer}>
                    <H3 sx={{
                        '@media (min-width: 1400px)': {
                            textWrap: 'balance',
                        },
                        '@media (min-width: 576px) and (max-width: 767px)': {
                            position: 'relative',
                            top: '4px',
                        },
                        '@media (min-width: 768px) and (max-width: 1199px)': {
                            fontSize: '32px',
                            lineHeight: 1.26,
                        },
                    }}>
                        {card.title}
                    </H3>
                    <div className={styles.scenarioItems}>
                        {card.list.map(({emoji, text}, index) => (
                            <div key={index} className={styles.scenarioItem}>
                                <span className={styles.scenarioEmoji}>{emoji}</span>
                                <List1 className={styles.itemText} sx={{
                                    minWidth: 0,
                                    overflowWrap: 'break-word',
                                    width: '100%',
                                    '@media (min-width: 576px) and (max-width: 767px)': {
                                        overflowWrap: 'normal',
                                        wordBreak: 'normal',
                                    },
                                }}>
                                    {typeof text === 'string' ? typografText(text) : text}
                                </List1>
                            </div>
                        ))}
                    </div>
                    {showScenarioButtons && (
                        <div className={styles.scenarioButtons}>
                            <ContainedButton icon={width <= 767 ? null : 'handshake'}>
                                Become a partner
                            </ContainedButton>
                            <OutlinedButton icon={demoIcon}>
                                Watch demo
                            </OutlinedButton>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return (
        <div className={cx(styles.card, {
            [styles.cardReversed]: isReversed,
        })}>
            <img className={styles.image} src={card.image} alt=""/>
            <div className={styles.textContainer}>
                <div className={styles.textContainerText}>
                    <div className={styles.textContainerTextLeft}>
                        <H3 sx={{
                            '@media screen and (min-width: 992px)': {
                                marginTop: '6px',
                            },
                        }}>{card.title}</H3>
                        <div className={styles.buttonsBlockMobile}>
                            <ContainedButton isBig>Become a partner</ContainedButton>
                            <OutlinedButton isBig>Watch demo</OutlinedButton>
                        </div>
                    </div>
                    <ul className={styles.list}>
                        {card?.list?.map(({emoji, text}, index) => (
                            <li key={index} className={styles.item}>
                                <span className={styles.emoji}>{emoji}</span>
                                <List1 className={styles.itemText}>
                                    {typeof text === 'string' ? typografText(text) : text}
                                </List1>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className={styles.buttonsBlock}>
                    <ContainedButton isBig>Become a partner</ContainedButton>
                    <OutlinedButton isBig>Watch demo</OutlinedButton>
                </div>
            </div>
        </div>
    );
}

export default ChecklistCard
